<template>
  <div class="accept">
    <h2>{{ message }}</h2>
  </div>
</template>

<script>
import { api } from '@/config'
import axios from 'axios'

export default {

  name: 'SubmissionAccept',
  data() {
    return {
      message: 'Loading...'
    }
  },
  mounted() {
    if (this.$route.query.code) {
      axios.post(api.submissionsAccept, {
        code: this.$route.query.code
      }).then(response => {
        if (response.data.status === 'success') {
          this.message = 'This video has been accepted.'
        } else {
          this.message = response.data.errors[0]
        }
      }).catch(err => {
        this.message = 'There was a database error. Please contact support.'
        console.log(err.response)
      })
    } else {
      this.message = 'Invalid link'
    }
  }
}
</script>

<style lang="scss" scoped>
.accept {
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
}
</style>
